export enum EXPERIENCE_STATUS {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
  DELETED = 'DELETED',
}

export type ExperienceStatus =
  (typeof EXPERIENCE_STATUS)[keyof typeof EXPERIENCE_STATUS];
